import {logging} from "@/utils/utils";

export default function productMasterApis($apiInstance, $store) {
    return {
        // 제품 마스터 목록 조회
        getProductMasters: async (params, success, fail) => {
            $store.commit('setIsLoading', true);

            try {
                const queryParams = new URLSearchParams();
                if (params.includeInactive) {
                    queryParams.append('includeInactive', 'true');
                }

                const url = `/subscription-product-masters${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
                const response = await $apiInstance.get(url);
                logging().exceptProd('제품 마스터 목록 조회==>', response.data);
                success(response);
            } catch (error) {
                console.error('제품 마스터 목록 조회 API 오류:', error);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },

        // 제품 마스터 상세 조회
        getProductMasterDetail: async (productId, success, fail) => {
            $store.commit('setIsLoading', true);

            try {
                const response = await $apiInstance.get(`/subscription-product-masters/${productId}`);
                logging().exceptProd('제품 마스터 상세 조회==>', response.data);
                success(response);
            } catch (error) {
                console.error('제품 마스터 상세 조회 API 오류:', error);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },

        // 제품 마스터 생성
        createProductMaster: async (productData, success, fail) => {
            $store.commit('setIsLoading', true);

            try {
                const response = await $apiInstance.post('/subscription-product-masters', productData);
                logging().exceptProd('제품 마스터 생성==>', response.data);
                success(response);
            } catch (error) {
                console.error('제품 마스터 생성 API 오류:', error);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },

        // 제품 마스터 수정
        updateProductMaster: async (productId, productData, success, fail) => {
            $store.commit('setIsLoading', true);

            try {
                const response = await $apiInstance.put(`/subscription-product-masters/${productId}`, productData);
                logging().exceptProd('제품 마스터 수정==>', response.data);
                success(response);
            } catch (error) {
                console.error('제품 마스터 수정 API 오류:', error);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },

        // 제품 마스터 삭제
        deleteProductMaster: async (productId, success, fail) => {
            $store.commit('setIsLoading', true);

            try {
                const response = await $apiInstance.delete(`/subscription-product-masters/${productId}`);
                logging().exceptProd('제품 마스터 삭제==>', response.data);
                success(response);
            } catch (error) {
                console.error('제품 마스터 삭제 API 오류:', error);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },
    }
}
